import React from 'react';
import Button from 'components/Button';

export interface ModerationOverflowMenuProps {
  /** Unique id for Bootstrap dropdown (multiple on page). */
  dropdownId: string;
  disabled?: boolean;
  onReportClick: () => void;
  onBlockClick: () => void | Promise<void>;
  /** Extra class for positioning (e.g. reel overlay). */
  className?: string;
}

/**
 * Kebab menu: report (opens modal via parent) and block user.
 */
const ModerationOverflowMenu: React.FC<ModerationOverflowMenuProps> = ({
  dropdownId,
  disabled = false,
  onReportClick,
  onBlockClick,
  className = '',
}) => {
  return (
    <div className={`dropdown ${className}`}>
      <Button
        type="button"
        className="btn btn-dark btn-sm rounded-circle opacity-75"
        id={dropdownId}
        data-bs-toggle="dropdown"
        aria-expanded="false"
        disabled={disabled}
        title="Daha fazla"
      >
        <i className="fas fa-ellipsis-v" />
      </Button>
      <ul className="dropdown-menu dropdown-menu-end" aria-labelledby={dropdownId}>
        <li>
          <button type="button" className="dropdown-item" onClick={onReportClick} disabled={disabled}>
            <i className="fas fa-flag me-2 text-warning" />
            Şikayet et
          </button>
        </li>
        <li>
          <button type="button" className="dropdown-item text-danger" onClick={() => void onBlockClick()} disabled={disabled}>
            <i className="fas fa-ban me-2" />
            Kullanıcıyı engelle
          </button>
        </li>
      </ul>
    </div>
  );
};

export default ModerationOverflowMenu;
